import { useQuery } from "@tanstack/react-query";
import type {
  StrandLossesFilters,
  StrandLossesResult,
} from "../../models/StrandLossByShift";
import { getStrandLosses } from "../../repositories/StrandLossesManagerRepository";

export const useStrandLossesQuery = (
  filters: StrandLossesFilters,
  enabled: boolean,
  onError?: (error: Error) => void,
) =>
  useQuery({
    queryKey: [
      "strand-losses-by-shift",
      filters.shiftId ?? null,
      filters.startDate ?? null,
      filters.endDate ?? null,
      filters.includeMicroDelays ?? false,
      filters.crew ?? null,
      filters.strandLossCodeId ?? null,
      filters.strandLossCategoryId ?? null,
      filters.strand ?? null,
      filters.minMinutes ?? null,
    ],
    meta: { realtime: ["RBD.GetStrandLossesByShift"] },
    queryFn: async ({ signal }): Promise<StrandLossesResult> => {
      const response = await getStrandLosses(filters, signal);
      if (!response.ok || !response.data) {
        throw new Error(response.message ?? "Failed to fetch Strand Losses");
      }
      return response.data;
    },
    enabled,
    onError,
  });
